import {ListViewProvider, useListView} from './core/ListViewProvider'
import {QueryRequestProvider} from './core/QueryRequestProvider'
import {QueryResponseProvider} from './core/QueryResponseProvider'
import {VisibilityEventListHeader} from './components/header/VisibilityEventListHeader'
import {VisibilityEventEditModal} from './visibility-event-modal/VisibilityEventEditModal'
import {KTCard} from '../../../../_metronic/helpers'
import { VisibilityEventTable } from './table/VisibilityEventTable'
import { VisibilityEventDeleteModal } from '../VisibilityEventDeleteModal'

const VisibilityEventList = () => {
  const {itemIdForUpdate, itemIdForDelete, helpPageOn, setHelpPageOn} = useListView()
  // const close = () => {
  //   setHelpPageOn(false)
  // }
  return (
    <>
      <KTCard>
        <VisibilityEventListHeader />
        <VisibilityEventTable />
      </KTCard>
      {/* {helpPageOn && <HelpModal closeFunction={() => close} />} */}
      {itemIdForUpdate !== undefined && <VisibilityEventEditModal />}
      {itemIdForDelete !== undefined && <VisibilityEventDeleteModal />}
    </>
  )
}

const VisibilityEventListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <VisibilityEventList />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export {VisibilityEventListWrapper}
